module.exports = __webpack_public_path__ + "img/car.2cf5f1ab.svg";